<template>
  <div id="app" class="content">

    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
  #app{
    margin-bottom: 0px;
  }

</style>
